import { Stack, Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import Media from "components/Molecules/Products/details/media";
import Thumbnail from "components/Molecules/Products/details/thumbnail";
import dayjs from "dayjs";

export const detailsData = ({ data, t }) => {
  return [
    {
      head: t("vendors.head_images"),
      icon: icons?.media,
      details: [
        {
          label: "",
          name: (
            <Stack direction="row" flexWrap="wrap" gap={2}>
              <Thumbnail src={data?.thumbnail} />
              <Media media={data?.media} />
            </Stack>
          ),
          width: "100%",
        },
      ],
    },
    {
      head: t("vendors.dates"),
      icon: icons?.dates,
      details: [
        {
          label: t("details.created_at"),
          name: dayjs(data?.created_at).format("DD-MM-YYYY HH-MM a"),
        },
        {
          label: t("details.updated_at"),
          name: dayjs(data?.updated_at).format("DD-MM-YYYY HH-MM a"),
        },
      ],
    },
    {
      head: t("products.label_details"),
      icon: icons?.details,
      details: [
        {
          label: t("products.col_vendor"),
          name: data?.store?.name,
          width: "100%",
        },
        {
          label: t("products.placeholder_name_en"),
          name: data?.localized_data?.en?.name,
        },
        {
          label: t("products.placeholder_name_ar"),
          name: data?.localized_data?.ar?.name,
        },
        {
          label: t("products.label_description_en"),
          name: data?.localized_data?.en?.description,
        },
        {
          label: t("products.label_description_ar"),
          name: data?.localized_data?.ar?.description ?? "-",
        },
        {
          label: t("products.label_gender"),
          name: (
            <Stack
              sx={{
                border: "1px solid #E6E6E6",
                borderRadius: "4px",
                width: "fit-content",
                p: 1,
              }}
            >
              {data?.target_gender}
            </Stack>
          ),
        },
        {
          label: t("products.label_select_age"),
          name: (
            <Stack
              sx={{
                border: "1px solid #E6E6E6",
                borderRadius: "4px",
                width: "fit-content",
                p: 1,
              }}
            >
              {data?.target_age}
            </Stack>
          ),
        },
        {
          label: t("products.label_occasions"),
          name: (
            <Stack direction="row" gap={1}>
              <Stack
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "4px",
                  width: "fit-content",
                  p: 1,
                }}
              >
                {data?.occasion_types_details?.length > 0 ? (
                  data?.occasion_types_details?.map((oc) => <>{oc.name}</>)
                ) : (
                  <Typography color="red">
                    {" "}
                    {t("products.error_no_occasion_selected")}{" "}
                  </Typography>
                )}
              </Stack>
            </Stack>
          ),
        },
        {
          label: t("products.label_preparation_time"),
          name: data?.preparation_time ? `${data.preparation_time} ${t("products.days")}` : "-",
        },
      ],
    },
    {
      head: t("products.label_prices"), // I need to add this key
      icon: icons?.fees,
      details: [
        {
          label: t("products.col_price"),
          name: (
            <Stack>
              {data?.price} {data?.currency?.name}
            </Stack>
          ),
          width: "30%",
        },
        {
          label: t("products.col_price_after_discount"),
          name: (
            <Stack>
              {data?.price_after_discount} {data?.currency?.name}
            </Stack>
          ),
          width: "30%",
        },
        {
          label: t("products.col_quantity"),
          name: data?.total_on_hand,
          width: "30%",
        },
      ],
    },
    {
      head: t("vendors.dates"),
      icon: icons?.dates,
      details: [
        {
          label: t("details.created_at"),
          name: dayjs(data?.created_at).format("DD-MM-YYYY HH-MM a"),
        },
        {
          label: t("details.updated_at"),
          name: dayjs(data?.updated_at).format("DD-MM-YYYY HH-MM a"),
        },
      ],
    },
  ];
};
